module.exports = __webpack_public_path__ + "media/14.38a82810.mp3";